// material ui
import { Dialog, Grid, Typography } from '@material-ui/core';
import React, { ReactElement } from 'react';

// api
import { IParam } from '~/src/dash/api/network';
// componennts
import { CopyButton } from '~/src/dash/components/button';
import { BlueBackground } from '~/src/dash/components/editor';
import { EndpointCustomTable } from '~/src/dash/components/endpoint-custom-table';
import { ModelWhiteButton } from '~/src/dash/components/model-white-button';
import { ModelParagraphSubtitle } from '~/src/dash/components/paragraph';
// other
import { getColorTheme } from '~/src/dash/resellers/utils/importResellerConfig';
import { IWithStylesProps } from '~/src/dash/types/props';
// utils
import { decorate } from '~/src/dash/utils/decorator';

// COMPONENT DESCRIPTION: StitchedURL used in the NetworkSettingsView to display the URL created by
// the endpoint builder.

// TODO: Use this component in SiteSettingsListView

interface IProps extends IWithStylesProps {
  // stitchedURL for display
  stitchedURL: string;
  currentParams: IParam[];
  requiredParams: string[];
  notEditableParams: string[];
  isUpdating: boolean;
  // permissions
  canEdit: boolean;
  // handlers
  handleSave: (params: IParam[]) => void;
}

interface IState {
  openEndpointParamsCustomizeMenu: boolean;
}

export const StitchedURL = decorate(
  {
    styles: (theme: any) => ({
      paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 4,
      },
    }),
  },
  class extends React.Component<IProps, IState> {
    state = {
      openEndpointParamsCustomizeMenu: false,
    };

    // renders model dialog to customize the endpoint params
    renderEndpointParamsCustomizeDialog = (): ReactElement => {
      const { openEndpointParamsCustomizeMenu } = this.state;
      const { currentParams, requiredParams, notEditableParams, handleSave } = this.props;
      return (
        <Dialog
          fullWidth
          maxWidth='sm'
          open={openEndpointParamsCustomizeMenu}
          onClose={() => {
            this.setState({
              openEndpointParamsCustomizeMenu: false,
            });
          }}
        >
          <EndpointCustomTable
            currentParams={currentParams}
            requiredParams={requiredParams}
            notEditableParams={notEditableParams}
            onSave={(params: IParam[]) => {
              handleSave(params);
              this.setState({
                openEndpointParamsCustomizeMenu: false,
              });
            }}
          />
        </Dialog>
      );
    };

    render() {
      const { stitchedURL, isUpdating, canEdit, classes } = this.props;
      return (
        <Grid
          item
          style={{
            marginTop: '20px',
          }}
        >
          {/* First row with sittched URL and tool tip */}
          <Grid item container direction='column' justify='flex-start'>
            <Grid item container direction='row' justify='flex-start' alignItems='center'>
              <Grid item>
                <img src='/assets/shared/svg/stitch_arrow.svg' />
              </Grid>
              <Grid item style={{ paddingLeft: 10, marginTop: -4 }}>
                <ModelParagraphSubtitle
                  style={{
                    fontWeight: 'bold',
                  }}
                >
                  Stitched URL
                </ModelParagraphSubtitle>
              </Grid>
            </Grid>
            <Typography
              style={{
                fontSize: 13,
                paddingBottom: 8,
              }}
            >
              Share this url with your distribution network, or copy & paste the URL below directly
              within your app to retrieve the stream of content + ads.
            </Typography>
          </Grid>

          {/* Blue text field */}
          <BlueBackground classes={{ root: classes.paper }}>
            <Typography style={{ width: 'inherit', wordBreak: 'break-word' }}>
              {stitchedURL}
            </Typography>
          </BlueBackground>

          {/* Copy Button and customize param values */}
          <Grid item container direction='row' justify='flex-start' alignItems='center'>
            <Grid item>
              <CopyButton
                style={{
                  fontSize: 15,
                  backgroundColor: 'rgba(239,239,239,0)',
                  color: getColorTheme('secondaryButtonText'),
                }}
                text='COPY'
                copy={stitchedURL}
              />
            </Grid>

            <Grid item style={{ paddingLeft: 10 }}>
              {canEdit && (
                <ModelWhiteButton
                  style={{ color: '#CC5B83' }}
                  onClick={() => {
                    this.setState({
                      openEndpointParamsCustomizeMenu: true,
                    });
                  }}
                  disabled={isUpdating}
                >
                  [-] Customize Params Value
                </ModelWhiteButton>
              )}
            </Grid>
          </Grid>

          {this.renderEndpointParamsCustomizeDialog()}
        </Grid>
      );
    }
  },
);
